import { v4 as uuidv4 } from 'uuid';

export function InfoCardList(props = {}, childrenComponents = []) {
	return {
		componentName: 'InfoCardList',
		componentId: uuidv4(),
		props,
		childrenComponents,
	};
}
